var toolbox = function () {
	$(function () {
		if ($("#track-form").length > 0) {
			$("#track-form").validate({
				messages: {
					trackingnumber: "Required"
				}
			});
		}
		
		if ($("#CalculateQuoteFormToolbox").length > 0) {
			$("#CalculateQuoteFormToolbox").validate({
				ignore: ":disabled",
				messages: {
					width: "Invalid",
					length: "Invalid",
					height: "Invalid",
					weight: "Invalid",
					value: "Invalid",
					OriginPlaceToolbox: "Required",
					DestinationPlaceToolbox: "Required",
					description: "Required"
				},
				submitHandler: function () {

					var formData = new FormData($(this)[0].currentForm);
                    var newtab = window.open('', '_getquote');

					$.ajax({
						type: "POST",
						url: "/umbraco/surface/calculatequote/calcquote",
						data: formData,
						contentType: false,
						processData: false,
						success: function (calculateQuoteUrl) {
							if (calculateQuoteUrl.length !== 0) {
								newtab.location = calculateQuoteUrl;
							}
						}
					});

					return false;
				}
			});
		}

		$("#OriginCountryToolbox").change(function () {

			if (this.value.indexOf("True") !== -1) {
				$("#OriginPlaceToolbox").prop("disabled", false);
			} else {
				$("#OriginPlaceToolbox").val("");
				$("#OriginPlaceToolbox").prop("disabled", true);
			}
		});

		$("#DestinationCountryToolbox").change(function () {

			if (this.value.indexOf("True") !== -1) {
				$("#DestinationPlaceToolbox").prop("disabled", false);
			} else {
				$("#DestinationPlaceToolbox").val("");
				$("#DestinationPlaceToolbox").prop("disabled", true);
			}
		});

		$("#OriginPlaceToolbox").autocomplete({
			source: function (request, response) {

				$.ajax({
					url: "/umbraco/surface/calculatequote/getcountryplaces",
					type: "GET",
					dataType: "json",
					data: {
						placeId: $("#OriginCountryToolbox").val(), filter: request.term
					},
					success: function (data) {

						var results = JSON.parse(data);

						// Populate the array that will be passed to the response callback.
						var autocompleteObjects = [];
						for (var i = 0; i < results.length; i++) {
							var object =
							{
								// Used by jQuery Autocomplete to show
								// autocomplete suggestions as well as
								// the text in yourInputTextBox upon selection.
								// Assign them to a value that you want the user to see.
								value: results[i].name,
								label: results[i].name,

								// Put our own custom id here.
								// If you want to, you can even put the result object.
								id: results[i].placeId
							};

							autocompleteObjects.push(object);
						}

						response(autocompleteObjects);
					}
				});
			},
			minLength: 2,
			select: function (event, ui) {
				$("#HiddenOriginPlaceToolbox").val(ui.item.id);
			}
		});

		$("#DestinationPlaceToolbox").autocomplete({
			source: function (request, response) {

				$.ajax({
					url: "/umbraco/surface/calculatequote/getcountryplaces",
					type: "GET",
					dataType: "json",
					data: {
						placeId: $("#DestinationCountryToolbox").val(), filter: request.term
					},
					success: function (data) {

						var results = JSON.parse(data);

						// Populate the array that will be passed to the response callback.
						var autocompleteObjects = [];
						for (var i = 0; i < results.length; i++) {
							var object =
							{
								// Used by jQuery Autocomplete to show
								// autocomplete suggestions as well as
								// the text in yourInputTextBox upon selection.
								// Assign them to a value that you want the user to see.
								value: results[i].name,
								label: results[i].name,

								// Put our own custom id here.
								// If you want to, you can even put the result object.
								id: results[i].placeId
							};

							autocompleteObjects.push(object);
						}

						response(autocompleteObjects);
					}
				});
			},
			minLength: 2,
			select: function (event, ui) {
				$("#HiddenDestinationPlaceToolbox").val(ui.item.id);
			}
		});

		if ($("#ToolboxEnquireForm").length > 0) {
			$("#ToolboxEnquireForm").validate({
				debug: true,
				submitHandler: function () {

					var formData = new FormData($(this)[0].currentForm);

					$.ajax({
						type: "POST",
						url: "/umbraco/surface/enquire/enquire",
						data: formData,
						contentType: false,
						processData: false,
						success: function (data) {
							$("#EnquiryFormResponse").removeClass("hidden");
							$("#EnquiryFormResponse p").text(data);
							$("#ToolboxEnquireForm").addClass("hidden");
							$(window).scrollTop(0);
						}
					});
					return false;
				}
			});
		}

	});
}

module.exports = toolbox;